import { render, staticRenderFns } from "./IdleMessage.vue?vue&type=template&id=5370d3c8&"
import script from "./IdleMessage.vue?vue&type=script&lang=js&"
export * from "./IdleMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports